<h1>{{ productCategory.description }}</h1>
<div *ngFor="let product of products">
  <h2>{{ product.title }}</h2>
  <p>{{ product.description }}</p>
  <p>{{ product.price }}</p>
</div>
